import { IS_PIN_ENABLED_KEY, PIN_UNLOCK_LOGIN_SESSION_KEY } from '../assets/constants'

function setBoth(key: string, value: string) {
	if (typeof sessionStorage !== 'undefined') sessionStorage.setItem(key, value)
	if (typeof localStorage !== 'undefined') localStorage.setItem(key, value)
}

function removeBoth(key: string) {
	if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(key)
	if (typeof localStorage !== 'undefined') localStorage.removeItem(key)
}

function getEither(key: string): string | null {
	if (typeof sessionStorage !== 'undefined') {
		const s = sessionStorage.getItem(key)
		if (s !== null) return s
	}
	if (typeof localStorage !== 'undefined') {
		return localStorage.getItem(key)
	}
	return null
}

export function isPinEnabledFlag(): boolean {
	return getEither(IS_PIN_ENABLED_KEY) === '1'
}

export function setPinEnabledFlag(enabled: boolean) {
	setBoth(IS_PIN_ENABLED_KEY, enabled ? '1' : '0')
}

export function applyPinEnabledFromUserProfile(user: unknown) {
	if (!user || typeof user !== 'object') return
	const o = user as Record<string, unknown>
	const v = o.isPinEnabled ?? o.is_pin_enabled
	if (typeof v === 'boolean') {
		setPinEnabledFlag(v)
	}
}

export function isPinUnlockPending(): boolean {
	return getEither(PIN_UNLOCK_LOGIN_SESSION_KEY) === '1'
}

export function setPinUnlockPending() {
	setBoth(PIN_UNLOCK_LOGIN_SESSION_KEY, '1')
}

export function clearPinUnlockPending() {
	removeBoth(PIN_UNLOCK_LOGIN_SESSION_KEY)
}

export function clearPinBrowserFlags() {
	removeBoth(IS_PIN_ENABLED_KEY)
	removeBoth(PIN_UNLOCK_LOGIN_SESSION_KEY)
}
